import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { useUserAuth } from 'common/queries-and-mutations/auth';
import { ErrorFallback } from 'components/ErrorFallback';
import { Loader } from 'components/Loader';
import SideBar from 'components/Navigation/SideBar';
import NavBar from 'components/Navigation/NavBar';
import { selectAccountDetails } from 'selectors/account-selector';
import { useAppSelector } from 'store/hooks';
import { userNavs } from 'constants/nav';
import NetworkStatus from 'components/NetworkStatus';
import { getStepPage } from 'constants/steps';

const ProtectedLayout = () => {
  const { isLoading } = useUserAuth();
  const [show, setShow] = useState<boolean>(false);
  const { user } = useAppSelector(selectAccountDetails);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Using this to check if the user have access to this page
  useEffect(() => {
    if (user && pathname) {
      const planAllowPage = user && JSON.parse(user.planAllowPage);
      const currentNav = userNavs.find(nav => nav.path === pathname);
      if (
        currentNav &&
        currentNav.pageId &&
        !planAllowPage.includes(currentNav.pageId)
      ) {
        navigate('/dashboard');
      }
    }
    //! Do not include navigate as part of deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, user]);

  //Using this to redirect user to the next page if user has not finish the onboarding
  useEffect(() => {
    if (user) {
      const pendingPage = user && JSON.parse(user.pendingPage);
      if (!user.onBoardingSkip && !user.isStepCompleted && pendingPage.length) {
        if (user && user?.nextStep) {
          navigate(`/dashboard/onboarding/${getStepPage(user?.nextStep)}`);
        }
      }
    }
    //! Do not include navigate, and/or user as part of deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="w-full">
      {!isLoading ? (
        <ErrorBoundary FallbackComponent={ErrorFallback as any}>
          {/* <div className="flex min-h-screen flex-col bg-[#F4F5F6]">
            <div className="mx-auto flex grow flex-col pb-20">
              <Menu />
            </div>
          </div> */}

          <div className="flex flex-col bg-[#F4F5F6] sm:w-min md:w-full">
            <div className="fixed bg-[#F4F5F6] sm:w-min md:flex md:w-full">
              <SideBar show={show} setShow={() => setShow(false)} />
              <div className="w-full flex-1">
                <NavBar
                  onClick={() => setShow(prevState => !prevState)}
                  setShow={() => setShow(false)}
                />
                <div className="mx-auto mt-10 flex h-screen w-[95%] grow flex-col overflow-y-auto p-4 pb-20 sm:mt-14 md:p-8 xl:w-[99%]">
                  <NetworkStatus />
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </ErrorBoundary>
      ) : (
        <div className="flex min-h-screen items-center justify-center">
          <Loader height={100} width={100} color="#FF7A00" />
        </div>
      )}
    </main>
  );
};

export default ProtectedLayout;
